import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { careerPath } from '../../data/careerPath';

/** Interactive rising pathway of career levels with Corventa's support at each stage. */
export function CareerPathway() {
  const [active, setActive] = useState(2);
  const current = careerPath[active];
  return <div className="rounded-xl bg-midnight p-6 md:p-10" data-id="element-553" data-mp="hzywxzhs44em">
      <div className="flex items-end gap-2 sm:gap-3" role="tablist" aria-label="Career levels" data-id="element-554" data-mp="wpd7vc106tw4">
        {careerPath.map((step, i) => {
        const isActive = i === active;
        return <button key={step.level} role="tab" type="button" aria-selected={isActive} aria-controls="career-panel" onClick={() => setActive(i)} className="group flex flex-1 flex-col items-stretch gap-3 text-left" data-id="element-555" data-mp="15r4csenpywox" data-mpi={i}>
              <span className={`block rounded-t-md border-t-2 transition-[background-color,border-color] duration-200 ${isActive ? 'border-gold bg-gold/25' : 'border-royal-300/40 bg-white/5 group-hover:bg-white/10'}`} style={{
            height: 48 + i * 30
          }} data-id="element-556" data-mp="33hxfvmu65csi" />
              <span className={`text-xs font-medium sm:text-sm ${isActive ? 'text-gold-300' : 'text-white/70'}`} data-id="element-557" data-mp="u7ar0772uw77">{step.level}</span>
            </button>;
      })}
      </div>
      <div id="career-panel" role="tabpanel" className="mt-8 min-h-[112px] border-t border-white/10 pt-6" data-id="element-558" data-mp="13ynhaud89eb4">
        <AnimatePresence mode="wait" data-id="element-559" data-mp="182lhl8eagv5r">
          <motion.div key={current.level} initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -6
        }} transition={{
          duration: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-560" data-mp="1cz3ityaeubdc">
            <h3 className="font-display text-2xl font-semibold text-white" data-id="element-561" data-mp="3etb8kfzb063c">{current.title}</h3>
            <p className="mt-2 max-w-xl leading-relaxed text-white/70" data-id="element-562" data-mp="3js5sxmcx62pk">{current.support}</p>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}